import { apiCall } from "./apiCall";

export default function devcoApi() {
  return {
    getDevcoBalance: (data, token) => apiCall("/getDevcoBalance", data, token),
    getDevcoFinancialData: (data, token) =>
      apiCall("/getDevcoFinancialData", data, token),
    getDevcoSalesData: (data, token) =>
      apiCall("/getDevcoSalesData", data, token),
    getDevcoProducts: (data, token) =>
      apiCall("/getDevcoProducts", data, token),
  };
}
